import { render, staticRenderFns } from "./CaseMergeModal.vue?vue&type=template&id=1d640c2b&scoped=true&"
import script from "./CaseMergeModal.vue?vue&type=script&lang=ts&"
export * from "./CaseMergeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d640c2b",
  null
  
)

export default component.exports